import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmDeletionComponent } from './dialogs/confirm-deletion/confirm-deletion.component';
import { PermanentlyDeleteComponent } from './dialogs/permanently-delete/permanently-delete.component';
import { PatientService } from 'src/app/services/patient/patient.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'mpp-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss'],
  standalone: false,
})
export class DeleteAccountComponent implements OnInit, OnDestroy {
  isEditMode = false;
  isError = false;
  isRevokeConsentVisible = false;
  shouldRevokeConsent = false;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private dialog: MatDialog,
    private patientService: PatientService,
  ) {}

  ngOnInit(): void {
    this.patientService
      .getPatient()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([patient]) => {
        if (!patient) return;
        const hipaaConsent = (patient as any).consents?.find(
          (c: any) => c.consentType === 'nightowlHipaa',
        );
        this.isRevokeConsentVisible = !!hipaaConsent && environment.hipaaEnabled;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  openEdit(): void {
    this.isEditMode = true;
  }

  cancelEdit(): void {
    this.isEditMode = false;
  }

  closeError(): void {
    this.isError = false;
  }

  openConfirmDeletion(): void {
    const dialogRef = this.dialog.open(ConfirmDeletionComponent, { disableClose: true });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.openPermanentlyDelete();
        return;
      }
      this.isEditMode = false;
    });
  }

  openPermanentlyDelete(): void {
    const dialogRef = this.dialog.open(PermanentlyDeleteComponent, {
      disableClose: true,
      data: {
        shouldRevokeConsent: this.isRevokeConsentVisible ? this.shouldRevokeConsent : undefined,
      },
    });
    dialogRef.afterClosed().subscribe((data) => {
      this.isEditMode = false;
      this.isError = data;
    });
  }
}
